import { translate } from '@gig/magic-common';
import { ValidationDisplay } from '@gig/magic-form-builder';
import { setReverseMonth } from '../../../utils/form-config.utils.js';
import { documentExpirationTypes } from './document.utils.js';

function documentExpiryDate(config) {
    if (config === void 0) { config = {}; }
    var formConfig = {
        id: 'document-expiry-wrapper',
        component: 'magic-ui-form-field',
        isDataField: false,
        children: [
            {
                id: 'document-expiry',
                component: 'magic-ui-date',
                testId: 'document-expiry',
                isStandAlone: true,
                isDataField: true,
                validationDisplay: ValidationDisplay.OnTouchShowMessage,
                properties: {
                    message: translate('verification-upload.document.expiry-invalid'),
                    futureDateOnly: true,
                },
                triggers: {
                    'document-type': onTypeChange,
                },
                converter: function (formValue) {
                    return {
                        ExpiresOn: new Date(formValue['document-expiry'].value).toISOString(),
                    };
                },
            },
        ],
    };
    if (config.reverseMonth) {
        setReverseMonth(formConfig);
    }
    return formConfig;
}
var onTypeChange = function (value, formData, setField) {
    var hidden = !documentExpirationTypes.includes(value);
    setField({
        id: 'document-expiry',
        hidden: hidden,
    });
};

export { documentExpiryDate };
